import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page82() {
  useEffect(() => {
    document.title = "Маяк — Страница 81"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page80" />
        <ForwardLink href="/page82" />
      </div>

      <p style={{ textAlign: "right" }}>81.</p>
      <p>СТАРИК выпивает.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Ооооо, мартышкин насос!
      </p>
      <p>Они оба пьют... дерутся из-за этого как легкомысленные дети.</p>
      <br/>
      <p>ВНУТРИ. ЗДАНИЕ ФОГОРНА. НОЧЬ</p>
      <p>
        РАКУРС НА: БАРОМЕТР. Стрелка падает. Она падает из положения<br/>
        “шторм” в пустое пространство внизу. За пределы графика, так сказать.
      </p>
      <br/>
      <p>СНАРУЖИ. МОРЕ – НОЧЬ</p>
      <p>
        ШИРОКИЙ ПЛАН: ГИГАНТСКИЕ ВОЛНЫ РАЗБИВАЮТСЯ. ГРОМ. МОЛНИЯ. КОНЕЦ<br/>
        БЛИЗОК.
      </p>
      <br/>
      <p>СНАРУЖИ. МАЯК – НОЧЬ</p>
      <p>ШИРОКИЙ ПЛАН: НА МАЯК ОБРУШИВАЮТСЯ СВИРЕПЫЕ 50-ФУТОВЫЕ ВОЛНЫ.</p>
      <p>
        РАКУРС НА: ЖИЛЫЕ ПОМЕЩЕНИЯ, ВОДА УДАРЯЕТ В КРЫШУ.<br/>
        Устоит ли она?
      </p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КАМБУЗ – НОЧЬ</p>
      <p>
        МОЛОДОЙ и СТАРИК смеются, смеются и смеются, держа в руках чашки<br/>
        воровского масла. МОЛОДОЙ все еще в пробковом жилете. ВОДА КАПАЕТ<br/>
        И ЛЬЕТСЯ С ПОТОЛКА
      </p>
      <p>ТОПОР в столешнице между ними.</p>
      <p>Они продолжают смеяться пугающе истерично...</p>
      <p>Смеются...</p>
      <p>Смеются...</p>
      <p>Смеются...</p>
      <p>Смеются...</p>
      <p>Смеются...</p>
      <p>
        ВНЕЗАПНО СИЛЬНАЯ ВОЛНА ПРОРЫВАЕТСЯ ЧЕРЕЗ ОКНО...<br/>
        ВОДА С БЫСТРОЙ СКОРОСТЬЮ ЗАЛИВАЕТ КОМНАТУ. Но МОЛОДОЙ и СТАРИК<br/>
        не замечают этого. Они продолжают смеяться...
      </p>
      <p>Смеются...</p>
      <p style={{ textAlign: "right" }}>81.</p>

      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page80" />
        <ForwardLink href="/page82" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710717292/the-lighthouse-script/q1zpofiphy9kiwi7ipmq.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page82;
